import React, { useEffect, useState } from 'react';

// Temporary diagnostic tool for the mobile ocean-centering bug. Only mounts
// when the URL has ?debug=1, so it never shows for a real visitor. Prints
// the real computed box of every ancestor in the shark-zone's centering
// chain so the actual offending element can be found from a screenshot
// instead of guessed at blind. Safe to delete once that bug is fixed.
const SELECTORS = [
  'html',
  'body',
  '.App',
  '.topingo-game',
  '.game-content',
  '.game-container',
  '.board-stage',
  '.game-board',
  '.shark-zone',
];

function readMetrics() {
  const lines = [];
  lines.push(`innerWidth: ${window.innerWidth}`);
  if (window.visualViewport) {
    lines.push(
      `visualViewport: w=${window.visualViewport.width.toFixed(1)} offsetLeft=${window.visualViewport.offsetLeft.toFixed(1)}`
    );
  }
  lines.push(
    `html scrollWidth/clientWidth: ${document.documentElement.scrollWidth}/${document.documentElement.clientWidth}`
  );
  SELECTORS.forEach((sel) => {
    const el = document.querySelector(sel);
    if (!el) {
      lines.push(`${sel}: (not found)`);
      return;
    }
    const rect = el.getBoundingClientRect();
    const cs = window.getComputedStyle(el);
    lines.push(
      `${sel}: left=${rect.left.toFixed(1)} width=${rect.width.toFixed(1)} right=${rect.right.toFixed(1)} | css width=${cs.width} margin-left=${cs.marginLeft} padding=${cs.paddingLeft}/${cs.paddingRight}`
    );
  });
  return lines.join('\n');
}

function DebugOverlay() {
  const [text, setText] = useState('');

  useEffect(() => {
    const update = () => setText(readMetrics());
    update();
    const id = setInterval(update, 500);
    return () => clearInterval(id);
  }, []);

  return (
    <pre
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 999999,
        margin: 0,
        padding: '6px 8px',
        background: 'rgba(0,0,0,0.85)',
        color: '#0f0',
        fontSize: '9px',
        lineHeight: 1.3,
        whiteSpace: 'pre-wrap',
        maxWidth: '100vw',
        maxHeight: '55vh',
        overflow: 'auto',
        pointerEvents: 'none',
      }}
    >
      {text}
    </pre>
  );
}

export default function DebugOverlayGate() {
  const enabled =
    typeof window !== 'undefined' && window.location.search.includes('debug=1');
  if (!enabled) return null;
  return <DebugOverlay />;
}
